import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

import Input from "~/components/Form/LandingInput"
import Spacer from "~/components/Spacer"
import FormError from "~/components/Form/ErrorText"
import withTranslations from "~/components/_hocs/withTranslations"

import InputTitle from "./InputTitle"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$compact ? "10px" : "0")};
`

@inject((all) => ({
  validateDisplayMessage: all.store.trafficLookup.validateDisplayMessage,
  email: all.store.trafficLookup.email,
  changeKey: all.store.trafficLookup.changeKey,
}))
@observer
class EmailInput extends Component {
  handleChange = (e) => {
    this.props.changeKey("email", e.target.value.toLowerCase().trim())
  }

  render() {
    const emailErrorHandler = this.props.validateDisplayMessage("email")
    const compact = this.props.compact
    return (
      <Wrap $compact={compact}>
        <InputTitle htmlFor="lookup-email">
          {this.props.translate("label")}
          {!compact && <Spacer direction="width" mobile={11} desktop={11} />}
        </InputTitle>
        {!compact && <Spacer desktop={16} mobile={4} />}
        <Input
          id="lookup-email"
          placeholder={this.props.translate("placeholder")}
          onChange={this.handleChange}
          value={this.props.email}
          error={emailErrorHandler}
          autoFocus={this.props.autofocus}
        />
        <FormError error={emailErrorHandler} />
      </Wrap>
    )
  }
}

export default withTranslations(EmailInput, "form.general.email")
